var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCpu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.85039 0.150391V1.15039H4.65039V0.150391H5.35039V1.15039H6.15039V0.150391H6.85039V1.15039H7.65039V0.150391H8.35039V1.15039H9.15039V0.150391H9.85039V1.15039H10.6504V0.150391H11.3504V1.15039H12.1454L13.3504 2.35542V3.15039H14.3504V3.85039H13.3504V4.65039H14.3504V5.35039H13.3504V6.15039H14.3504V6.85039H13.3504V7.65039H14.3504V8.35039H13.3504V9.15039H14.3504V9.85039H13.3504V10.6504H14.3504V11.3504H13.3504V12.1454L12.1454 13.3504H11.3504V14.3504H10.6504V13.3504H9.85039V14.3504H9.15039V13.3504H8.35039V14.3504H7.65039V13.3504H6.85039V14.3504H6.15039V13.3504H5.35039V14.3504H4.65039V13.3504H3.85039V14.3504H3.15039V13.3504H2.35542L1.15039 12.1454V11.3504H0.150391V10.6504H1.15039V9.85039H0.150391V9.15039H1.15039V8.35039H0.150391V7.65039H1.15039V6.85039H0.150391V6.15039H1.15039V5.35039H0.150391V4.65039H1.15039V3.85039H0.150391V3.15039H1.15039V2.35542L2.35542 1.15039H3.15039V0.150391H3.85039ZM2.64537 1.85039L1.85039 2.64537V11.8554L2.64536 12.6504H11.8554L12.6504 11.8554V2.64536L11.8554 1.85039H2.64537ZM3.15039 3.15039H11.3504V11.3504H3.15039V3.15039ZM3.85039 3.85039V10.6504H10.6504V3.85039H3.85039ZM4.65039 6.15039H9.85039V6.85039H4.65039V6.15039ZM5.65039 7.65039H8.85039V8.35039H5.65039V7.65039Z",
    fill: "currentColor",
    fillOpacity: 0.45
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpu);
export default __webpack_public_path__ + "static/media/cpu.7238d761.svg";
export { ForwardRef as ReactComponent };